module.exports = __webpack_public_path__ + "static/1-copy-9c99c6b8516e8cb25ce654fd7c937677.jpg";